(() => {
  const syncHeaderState = () => {
    const scrolled = window.scrollY > 24;
    document.body.classList.toggle('ll-page-scrolled', scrolled);
    document.querySelectorAll('.ll-site-chrome').forEach((chrome) => {
      chrome.classList.toggle('ll-page-scrolled', scrolled);
    });
  };

  const initComparison = (root) => {
    const range = root.querySelector('[data-ll-comparison-range]');
    const stage = root.querySelector('[data-ll-comparison-stage]');
    if (!range || !stage) return;
    const update = () => stage.style.setProperty('--ll-position', `${range.value}%`);
    range.addEventListener('input', update);
    update();
  };

  const initRoutine = (root) => {
    const tabs = [...root.querySelectorAll('[data-ll-routine-tab]')];
    const panels = [...root.querySelectorAll('[data-ll-routine-panel]')];
    if (!tabs.length || !panels.length) return;
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const target = tab.getAttribute('aria-controls');
      tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
      panels.forEach((panel) => panel.classList.toggle('is-active', panel.id === target));
    }));
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-ll-comparison]').forEach(initComparison);
    scope.querySelectorAll('[data-ll-routine]').forEach(initRoutine);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('scroll', syncHeaderState, { passive: true });
  syncHeaderState();
})();
